



















import Component from 'vue-class-component'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { OrganisationLite } from '@/business/organisation/interfaces/organisation-lite'
import { activeUserIsOwner } from '@/shared/utils/user'
import { Anonymous } from '@/authentication/models/Anonymous'
import { AuthenticationModule } from '@/authentication/store/authentication-module'
import { Injector } from '@/config/dependency-injection'

@Component({
  name: 'respondeco-contact-author',
})
export default class RespondecoContactAuthor extends Vue {
  @Prop({
    required: true,
    type: Object,
  })
  public readonly organisation!: OrganisationLite

  public activeUserIsOwner = activeUserIsOwner

  private authenticationModule = Injector.get(AuthenticationModule)

  get activeUser() {
    return this.authenticationModule.authenticatedUser
  }

  get activeUserIsNotAnonymous() {
    return this.activeUser !== Anonymous
  }
}
